import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "grid-alt",
  "use": "grid-alt-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"grid-alt\"><path d=\"M480 512H32c-17.688 0-32-14.312-32-32V32C0 14.312 14.312 0 32 0h448c17.688 0 32 14.312 32 32v448c0 17.688-14.312 32-32 32zM448 64H64v384h384V64zM224 224h-96v-96h96v96zm0 160h-96v-96h96v96zm160-160h-96v-96h96v96zm0 160h-96v-96h96v96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/grid-alt.svg
// module id = TMew
// module chunks = 1